import { useState, useEffect } from 'react';
import { authService } from '../services/auth';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // États pour la connexion
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState(null);

  // Vérifier l'authentification au démarrage
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    try {
      setLoading(true);
      
      const storedData = authService.getStoredData();
      
      if (storedData && storedData.token) {
        setIsAuthenticated(true);
        setUser(storedData.user || null);
        setBusiness(storedData.business || null);
      } else {
        setIsAuthenticated(false);
        setUser(null);
        setBusiness(null);
      }
    } catch (error) {
      console.error('Erreur vérification auth:', error);
      setIsAuthenticated(false);
      setUser(null);
      setBusiness(null);
      authService.clearStoredData();
    } finally {
      setLoading(false);
    }
  };

  // Fonction de connexion
  const login = async (email, password) => {
    try {
      setLoginLoading(true);
      setLoginError(null);

      console.log('Début du processus de connexion...');
      
      // 1. Vérifier le statut MFA
      console.log('Vérification MFA...');
      const mfaStatus = await authService.checkMFAStatus(email, password);
      console.log('Statut MFA:', mfaStatus);
      
      if (mfaStatus === "YES") {
        setLoginError('Authentification à deux facteurs requise');
        return false;
      }
      
      // 2. Effectuer la connexion standard
      console.log('Tentative de connexion standard...');
      const result = await authService.performStandardLogin(email, password);
      
      // 3. Mettre à jour l'état
      setIsAuthenticated(true);
      setUser(result.user);
      setBusiness(result.business);
      
      console.log('Connexion réussie!');
      return true;
      
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      setLoginError(error.message || 'Échec de la connexion');
      return false;
    } finally {
      setLoginLoading(false);
    }
  };

  // Fonction de déconnexion
  const logout = () => {
    authService.clearStoredData();
    setIsAuthenticated(false);
    setUser(null);
    setBusiness(null);
    window.location.href = '/login';
  };

  return {
    // États d'authentification
    isAuthenticated,
    user,
    business,
    loading,
    error,
    
    // États de connexion
    loginLoading,
    loginError,
    
    // Fonctions
    login,
    logout,
    checkAuth,
    
    // Pour la page de connexion
    setLoginError
  };
};